import { ArrowLeftRight, CalendarDays, Repeat } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { fmtWhen } from "./shiftFormat";

const hours = (s) => Math.max(0, (new Date(s.end) - new Date(s.start)) / 3600000);

// Your own upcoming shifts, with the Weekly tag and a Swap / drop button.
export const MyShiftsCard = ({ shifts = [], onRequest, title = "Upcoming shifts", hideWhenEmpty = false }) => {
  if (hideWhenEmpty && shifts.length === 0) return null;
  return (
    <Card className="p-4" data-testid="schedule-mine-card">
      <div className="text-xs uppercase tracking-widest font-bold text-zinc-500 mb-3 flex items-center gap-1.5">
        <CalendarDays className="h-4 w-4"/>{title}
      </div>
      {shifts.length === 0 ? (
        <div className="text-sm text-zinc-400 py-6 text-center" data-testid="schedule-empty">No upcoming shifts scheduled.</div>
      ) : (
        <ul className="space-y-2" data-testid="schedule-mine-list">
          {shifts.map((s) => (
            <li key={s.id} className="flex items-center justify-between gap-3 rounded-lg border border-zinc-200 dark:border-zinc-800 px-3 py-2.5" data-testid={`schedule-shift-${s.id}`}>
              <div className="min-w-0">
                <div className="font-semibold text-sm flex items-center gap-2 flex-wrap">
                  {fmtWhen(s.start)} → {fmtWhen(s.end)}
                  {s.series_id && (
                    <span className="inline-flex items-center gap-1 rounded-full bg-violet-500/10 text-violet-600 dark:text-violet-300 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide" data-testid={`schedule-mine-series-badge-${s.id}`}>
                      <Repeat className="h-3 w-3"/>Weekly
                    </span>
                  )}
                </div>
                {s.note ? <div className="text-[11px] text-zinc-500 mt-0.5">{s.note}</div> : null}
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-xs font-bold tabular-nums text-zinc-500">{hours(s).toFixed(1)}h</span>
                {new Date(s.start).getTime() > Date.now() && (
                  <Button size="sm" variant="outline" onClick={() => onRequest(s)} data-testid={`schedule-request-change-${s.id}`} className="h-8 text-xs">
                    <ArrowLeftRight className="h-3.5 w-3.5 mr-1"/>Swap / drop
                  </Button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
};

export default MyShiftsCard;
